<template>
    <ul class="w-full">
        <!-- list of PROGRAMS -->
        <li
            v-for="(sourcePointsProgram, index) in sourceProgramUserPoints"
            :key="index"
        >
            <div
                class="w-full h-auto justify-start items-start flex flex-row gap-1 @3xl:flex-col @3xl:gap-4"
            >
                <!-- Sublist of USERS for this PROGRAM -->
                <!-- START SINGLE TRANSFER OPTION -->
                <PointsCard
                    v-for="user in sourcePointsProgram.points"
                    :destinationProgramName="programName"
                    :destinationProgramImage="programImage"
                    :hasEnoughProgramPoints="user.hasEnoughProgramPoints"
                    :isTransfer="true"
                    :sourceProgram="sourcePointsProgram"
                    :user="user"
                    :usersCount="sourcePointsProgram.points.length"
                    :key="user.id"
                />
                <!-- END SINGLE TRANSFER OPTION -->
                <!-- END SUBLIST OF USERS -->
            </div>
            <!-- start brand logo -->
            <div
                class="self-stretch h-12 pt-6 flex-col justify-start items-start gap-2.5 flex"
            >
                <img :src="'/' + sourcePointsProgram.image" class="h-full" />
            </div>
            <!-- end brand logo -->
            <!-- start bonus info -->
            <div
                class="self-stretch h-7 pt-2 flex-col justify-start items-start gap-2.5 flex"
                v-if="
                    sourcePointsProgram.bonusRateFrom &&
                    bonusIsActive(
                        sourcePointsProgram.bonusStart,
                        sourcePointsProgram.bonusExpiration
                    )
                "
            >
                <div
                    class="px-3 py-0.5 bg-orange-50 rounded-[999px] justify-center items-center gap-2.5 inline-flex"
                >
                    <div
                        class="text-orange-600 text-xs font-medium leading-none"
                    >
                        {{
                            $filters.bonusTransferAsPercentage(
                                sourcePointsProgram.transferRateTo /
                                    sourcePointsProgram.transferRateFrom,
                                sourcePointsProgram.bonusRateTo /
                                    sourcePointsProgram.bonusRateFrom
                            )
                        }}
                        Transfer Bonus until
                        {{
                            $filters.formatShortDate(
                                sourcePointsProgram.bonusExpiration
                            )
                        }}
                    </div>
                </div>
            </div>
            <!-- end bonus info -->
            <!-- start view transfer details -->
            <div
                class="self-stretch h-12 pt-3 flex-col justify-start items-start gap-2.5 flex"
                v-if="sourcePointsProgram.transferInstructions"
            >
                <button
                    class="h-9 px-4 py-2 bg-white rounded shadow border border-slate-200 justify-start items-start gap-2 flex hover:bg-slate-200 active:bg-slate-200 focus:outline-slate-200 focus:border-slate-200 hover:border-slate-300 active:border-slate-300"
                    @click.prevent="
                        () => {
                            onOpen();
                            openModal();
                        }
                    "
                >
                    <div
                        class="text-slate-800 text-sm font-medium leading-tight"
                    >
                        View transfer details
                    </div>
                    <div
                        class="w-5 h-5 pl-[5.20px] pr-[5.01px] pt-[3px] pb-[7.21px] justify-center items-center flex"
                    >
                        <i class="fa-solid fa-arrow-up-right"></i>
                    </div>
                </button>
                <TransferInstructions
                    :loading="loading"
                    :iframe="sourcePointsProgram.transferInstructions"
                    :destinationProgram="programName"
                    :sourceProgram="sourcePointsProgram.programName"
                    :show="show"
                    @close="closeModal"
                />
            </div>
            <!-- end view transfer details -->
            <div
                class="w-[304px] h-[65px] py-8 flex-col justify-start items-start inline-flex"
                v-if="index < sourceProgramUserPoints.length - 1"
            >
                <div
                    class="self-stretch h-px bg-gradient-to-r from-slate-200 via-slate-200 to-slate-200"
                ></div>
            </div>
        </li>
    </ul>
</template>
<script>
import { ref, watchEffect } from 'vue';
import dayjs from 'dayjs';
import PointsCard from '@/components/hotels/property/points-card/points-card.vue';
import TransferInstructions from '@/components/hotels/modals/transfer-instructions.vue';

export default {
    components: {
        PointsCard,
        TransferInstructions,
    },
    props: {
        programName: String,
        programImage: String,
        sourceProgramUserPoints: Array,
    },
    setup(props) {
        const loading = ref(true);
        const show = ref(false);

        watchEffect(() => {
            if (props.programName) {
                loading.value = false;
            }
        });

        const bonusIsActive = (startDate, endDate) => {
            const today = dayjs();

            const beginDate = dayjs(startDate).format('YYYY-MM-DD');
            const expirationDate = dayjs(endDate).format('YYYY-MM-DD');
            const todayFormatted = today.format('YYYY-MM-DD');

            return (
                expirationDate >= todayFormatted && todayFormatted <= beginDate
            );
        };
        const onOpen = () => {
            loading.value = true;
            setTimeout(() => {
                loading.value = false;
            }, 2500);
        };

        const openModal = () => {
            show.value = true;
        };

        const closeModal = () => {
            show.value = false;
        };

        return {
            bonusIsActive,
            closeModal,
            loading,
            onOpen,
            openModal,
            show,
        };
    },
};
</script>
